import { CreatePlanDataTypes } from '../OperationalPlanner.types'
import { SourceSiteDetails } from '../WorkcentreModal/WorkcentreModal.types'

// Action Types
export const PLAN_DATA_ACTIONS = {
  SET_PLAN_DATA: 'SET_PLAN_DATA',
  SET_PLAN_START_WEEK: 'SET_PLAN_START_WEEK',
  SET_PLAN_DESCRIPTION: 'SET_PLAN_DESCRIPTION',
  SET_PLAN_HORIZON: 'SET_PLAN_HORIZON',
  SET_PLAN_HORIZON_DATE: 'SET_PLAN_HORIZON_DATE',
  SET_CONSTRAINING_HORIZON: 'SET_CONSTRAINING_HORIZON',
  SET_CONSTRAINING_HORIZON_DATE: 'SET_CONSTRAINING_HORIZON_DATE',
  SET_PLAN_ACCESS_TYPE: 'SET_PLAN_ACCESS_TYPE',
  SET_SOURCE_SITES: 'SET_SOURCE_SITES',
  UPDATE_HORIZON_DATA: 'UPDATE_HORIZON_DATA',
  UPDATE_WORKCENTRE_CONSTRAINING_DATA: 'UPDATE_WORKCENTRE_CONSTRAINING_DATA',
} as const

// Action Types
export type PlanDataAction =
  | {
      type: typeof PLAN_DATA_ACTIONS.SET_PLAN_DATA
      payload: CreatePlanDataTypes
    }
  | { type: typeof PLAN_DATA_ACTIONS.SET_PLAN_START_WEEK; payload: Date }
  | { type: typeof PLAN_DATA_ACTIONS.SET_PLAN_DESCRIPTION; payload: string }
  | { type: typeof PLAN_DATA_ACTIONS.SET_PLAN_HORIZON; payload: number }
  | { type: typeof PLAN_DATA_ACTIONS.SET_PLAN_HORIZON_DATE; payload: Date }
  | { type: typeof PLAN_DATA_ACTIONS.SET_CONSTRAINING_HORIZON; payload: number }
  | {
      type: typeof PLAN_DATA_ACTIONS.SET_CONSTRAINING_HORIZON_DATE
      payload: Date
    }
  | { type: typeof PLAN_DATA_ACTIONS.SET_PLAN_ACCESS_TYPE; payload: string }
  | {
      type: typeof PLAN_DATA_ACTIONS.SET_SOURCE_SITES
      payload: SourceSiteDetails[]
    }
  | {
      type: typeof PLAN_DATA_ACTIONS.UPDATE_HORIZON_DATA
      payload: {
        planStartWeek: Date
        planHorizon: number
        constrainingHorizon: number
        planHorizonDate: Date
        constrainingHorizonDate: Date
      }
    }
  | {
      type: typeof PLAN_DATA_ACTIONS.UPDATE_WORKCENTRE_CONSTRAINING_DATA
      payload: SourceSiteDetails[]
    }

// Reducer Function
export const planDataReducer = (
  state: CreatePlanDataTypes,
  action: PlanDataAction
): CreatePlanDataTypes => {
  switch (action.type) {
    case PLAN_DATA_ACTIONS.SET_PLAN_DATA:
      return action.payload

    case PLAN_DATA_ACTIONS.SET_PLAN_START_WEEK:
      return {
        ...state,
        planStartWeek: action.payload,
      }

    case PLAN_DATA_ACTIONS.SET_PLAN_DESCRIPTION:
      return {
        ...state,
        planDescription: action.payload,
      }

    case PLAN_DATA_ACTIONS.SET_PLAN_HORIZON:
      return {
        ...state,
        planHorizon: action.payload,
      }

    case PLAN_DATA_ACTIONS.SET_PLAN_HORIZON_DATE:
      return {
        ...state,
        planHorizonDate: action.payload,
      }

    case PLAN_DATA_ACTIONS.SET_CONSTRAINING_HORIZON:
      return {
        ...state,
        constrainingHorizon: action.payload,
      }

    case PLAN_DATA_ACTIONS.SET_CONSTRAINING_HORIZON_DATE:
      return {
        ...state,
        constrainingHorizonDate: action.payload,
      }

    case PLAN_DATA_ACTIONS.SET_PLAN_ACCESS_TYPE:
      return {
        ...state,
        planAccessType: action.payload,
      }

    case PLAN_DATA_ACTIONS.SET_SOURCE_SITES:
      return {
        ...state,
        sourceSites: action.payload,
      }

    case PLAN_DATA_ACTIONS.UPDATE_HORIZON_DATA:
      return {
        ...state,
        ...action.payload,
      }

    case PLAN_DATA_ACTIONS.UPDATE_WORKCENTRE_CONSTRAINING_DATA:
      return {
        ...state,
        sourceSites: action.payload,
      }

    default:
      return state
  }
}
